<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <button
    class="py-1 px-5 border border-[#d9d9d9] rounded"
    (click)="onGroupMapClick()"
    [disabled]="selectedIssuers.length < 2"
    [ngClass]="{
      'bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]':
        selectedIssuers.length >= 2,
      'bg-white text-gray-800 cursor-not-allowed': selectedIssuers.length < 2
    }"
    pTooltip="{{
      selectedIssuers.length < 2
        ? 'Select at least two rows to enable grouping'
        : ''
    }}"
    tooltipPosition="top"
  >
    Group Map
  </button>

  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerName"
    type="text"
    placeholder="Search by company name"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'issuerName')"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="cikNumber"
    type="text"
    placeholder="Search by cik number"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'cikNumber')"
  />
</div>

<div class="mb-4"></div>

<p-table
  [value]="unprocessedIssuers"
  [paginator]="unprocessedIssuers.length > 0"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [(selection)]="selectedIssuers"
  dataKey="asReportedIssuerId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th style="width: 4rem">
        <p-tableHeaderCheckbox />
      </th>
      <th>A R C. Id</th>
      <th>Company Name</th>
      <th>CIK</th>
      <th>EIN</th>
      <th>SIC</th>
      <th>File No</th>
      <th>Year End</th>
      <th>State of Incorporation</th>
      <th>Actions</th>
    </tr>
  </ng-template>
  <ng-template #body let-issuer>
    <tr>
      <td>
        <p-tableCheckbox [value]="issuer" />
      </td>
      <td>
        {{ issuer.asReportedIssuerId || "N/A" }}
      </td>
      <td>{{ issuer.asReportedIssuerName || "N/A" }}</td>
      <td>{{ issuer.asReportedCik || "N/A" }}</td>
      <td>{{ issuer.asReportedEin || "N/A" }}</td>
      <td>{{ issuer.asReportedSic || "N/A" }}</td>
      <td>{{ issuer.asReportedFileNumber || "N/A" }}</td>
      <td>{{ issuer.asReportedFiscalYearEnd || "N/A" }}</td>
      <td>{{ issuer.asReportedStateOfIncorporation || "N/A" }}</td>

      <td>
        <button
          class="bg-white cursor-pointer hover:bg-gray-100 text-gray-800 py-1 px-3 border border-gray-400 rounded"
          (click)="openMapModal(issuer, $event)"
        >
          Map
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-container *ngIf="!isLoading && unprocessedIssuers.length === 0">
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>
